import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


// TODO: Separate navigation flyout logic from Tooltip logic
const TooltipHOC = function TooltipHOComponent(WrappedComponent) {
  class TooltipHOC extends Component {
    constructor(props) {
      super(props);
      this.msgRef = React.createRef();
      this.tooltipPositionRef = React.createRef();
      this.config = {
        msgPadding: 20,
        iconDimensions: 0,
        alignMsg: 'left',
        expandOnFocus: true,
      };

      this.setConfig = this.setConfig.bind(this);
      this.toggleTooltip = this.toggleTooltip.bind(this);
      this.renderMsgBlock = this.renderMsgBlock.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this);

      this.state = { showTooltip: false, position: {}, shiftLeft: { left: 0 } };
    }

    componentDidUpdate(prevProps, prevState) {
      const { showTooltip } = this.state;

      if (prevState.showTooltip !== showTooltip) {
        this.positionMsgInWindow();
      }
    }

    componentWillUnmount() {
      this.handleEventListeners(false);
    }

    setConfig(config) {
      this.config = {
        ...this.config,
        ...config,
      };
    }

    getTooltipPosition() {
      const shiftCoefficient = 1.5;
      const { alignMsg, iconDimensions } = this.config;
      const rect = this.tooltipPositionRef.current.getBoundingClientRect();
      const { offsetTop } = this.tooltipPositionRef.current;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

      return {
        rightEdgePosition: rect.left + scrollLeft,
        left: rect[alignMsg] + scrollLeft - (iconDimensions * shiftCoefficient),
        top: offsetTop + rect.height,
      };
    }

    toggleTooltip(show, { type }) {
      const { expandOnFocus } = this.config;

      if (type === 'focus' && !expandOnFocus) {
        return;
      }

      const { showTooltip } = this.state;

      if (show !== showTooltip) {
        if (show) {
          const position = this.getTooltipPosition();

          if (position.rightEdgePosition <= document.documentElement.clientWidth) {
            this.handleEventListeners(true);
            this.setState({ showTooltip: true, position });
          }
        } else {
          this.handleEventListeners(false);
          this.setState({ showTooltip: false });
        }
      }
    }

    handleEventListeners(tooltipOpen) {
      if (tooltipOpen) {
        window.addEventListener('keyup', this.handleKeyPress);
        window.addEventListener('click', this.handleOutsideClick);
        window.addEventListener('touchstart', this.handleOutsideClick);
      } else {
        window.removeEventListener('keyup', this.handleKeyPress);
        window.removeEventListener('click', this.handleOutsideClick);
        window.removeEventListener('touchstart', this.handleOutsideClick);
      }
    }

    handleOutsideClick() {
      this.toggleTooltip(false);
    }

    handleKeyPress({ key, target, type }) {
      const { expandOnFocus } = this.config;

      if (type === 'focus' && expandOnFocus) {
        return;
      }

      const escapeKeyPressed = key === 'Escape';
      let showTooltip = false;

      if (this.tooltipPositionRef.current) {
        showTooltip = escapeKeyPressed ? false : this.tooltipPositionRef.current.contains(target);
      }
      this.toggleTooltip(showTooltip, { type });
    }

    positionMsgInWindow() {
      const xPosition = this.msgRef.current.getBoundingClientRect().right;
      const windowWidth = document.documentElement.clientWidth;
      const rightEdgePosition = this.config.msgPadding + xPosition;
      const shift = rightEdgePosition > windowWidth ? windowWidth - rightEdgePosition : 0;

      this.setState({ shiftLeft: { left: `${shift}px` } });
    }

    renderMsgBlock(msgBlock) {
      const { id, styleFlag } = this.props;
      const { showTooltip, shiftLeft, position } = this.state;
      const showTooltipClass = classNames('marketplace-tooltip__msg', { 'marketplace-tooltip__msg--visible': showTooltip });

      return (
        <span className={`tooltip--${styleFlag}`}>
          <span className={showTooltipClass} id={id} style={position}>
            <span className="marketplace-tooltip__marker" />
            <span
              ref={this.msgRef}
              style={shiftLeft}
              className="marketplace-tooltip__msg-container"
            >
              {msgBlock}
            </span>
          </span>
        </span>
      );
    }

    render() {
      const { showTooltip } = this.state;
      const { id, navItem, title } = this.props;

      return (
        <span
          className="marketplace-tooltip"
          aria-controls={id}
          aria-describedby={id}
          aria-label={`${title} tooltip`}
          aria-expanded={showTooltip}
          role="button"
          tabIndex={0}
          ref={this.tooltipPositionRef}
          onKeyPress={navItem ? this.handleKeyPress : event => this.toggleTooltip(false, event)}
          onFocus={event => this.toggleTooltip(true, event)}
          onMouseOver={event => this.toggleTooltip(true, event)}
          onMouseLeave={event => this.toggleTooltip(false, event)}
          onTouchEnd={event => this.toggleTooltip(true, event)}
          onClick={event => event.stopPropagation()}
        >
          <WrappedComponent
            {...this.props}
            state={this.state}
            setConfig={this.setConfig}
            renderMsgBlock={this.renderMsgBlock}
            toggleTooltip={this.toggleTooltip}
          />
        </span>
      );
    }
  }

  TooltipHOC.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    styleFlag: PropTypes.string,
    navItem: PropTypes.shape({
      name: PropTypes.string.isRequired,
      subGroups: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  };
  TooltipHOC.defaultProps = {
    id: null,
    title: 'Navigation',
    styleFlag: 'tax',
    navItem: null,
  };

  return TooltipHOC;
};

export default TooltipHOC;
